"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.badgePosition = exports.badgeSize = exports.badgeType = exports.badgeNovoDark = exports.badgeNovo = exports.badge = void 0;
const oxygen_theme_1 = __importDefault(require("@8x8/oxygen-theme"));
const color_const_1 = __importDefault(require("../choices/color.const"));
const size_const_1 = __importDefault(require("../choices/size.const"));
const font_const_1 = __importDefault(require("../choices/font.const"));
const { novo } = oxygen_theme_1.default;
const badge = {
    backgroundColorPrimary: color_const_1.default.coral400,
    backgroundColorSecondary: color_const_1.default.goldenBell,
    fontColorPrimary: color_const_1.default.white,
    fontColorSecondary: color_const_1.default.pickledBluewood800,
    fontFamily: font_const_1.default.family,
    fontSizeBig: font_const_1.default.sizeXs,
    fontSizeMedium: font_const_1.default.sizeXs,
    fontSizeSmall: 0,
    fontWeight: 400,
    lineHeightBig: font_const_1.default.lineHeightSm,
    lineHeightMedium: font_const_1.default.lineHeightXs,
    lineHeightSmall: 0,
    paddingBig: size_const_1.default.small,
    paddingMedium: size_const_1.default.small,
    paddingSmall: 0,
    positionOuterBig: '10px',
    positionOuterMedium: '8px',
    positionOuterSmall: '3px',
    sizeBig: size_const_1.default.medium,
    sizeMedium: '18px',
    sizeSmall: size_const_1.default.default,
};
exports.badge = badge;
const badgeNovo = {
    ...badge,
    backgroundColorPrimary: novo.warning01,
    backgroundColorSecondary: novo.warning01,
    fontColorPrimary: novo.textColor01,
    fontColorSecondary: novo.textColor01,
    fontFamily: novo.labelBold01.fontFamily,
    fontSizeMedium: novo.labelBold01.fontSize,
    fontSizeBig: novo.labelBold01.fontSize,
    fontWeight: novo.labelBold01.fontWeight,
    lineHeightMedium: novo.labelBold01.lineHeight,
    lineHeightBig: novo.labelBold01.lineHeight,
    paddingMedium: novo.spacing02,
    sizeBig: '1rem',
    sizeMedium: '1rem',
    sizeSmall: '0.75rem',
    positionOuterBig: '0.5rem',
    positionOuterMedium: '0.5rem',
    positionOuterSmall: '0.375rem',
};
exports.badgeNovo = badgeNovo;
const badgeNovoDark = {
    ...badgeNovo,
};
exports.badgeNovoDark = badgeNovoDark;
const badgeType = {
    primary: 'primary',
    secondary: 'secondary',
};
exports.badgeType = badgeType;
const badgeSize = {
    small: 'small',
    medium: 'medium',
    big: 'big',
};
exports.badgeSize = badgeSize;
const badgePosition = {
    topLeft: 'tl',
    topRight: 'tr',
    bottomLeft: 'bl',
    bottomRight: 'br',
};
exports.badgePosition = badgePosition;
